import React from 'react'
import styles from './ArrowButton.module.css'

interface ArrowButtonProps {
    icon: React.ReactNode|string
    name: string
    onClick: () => void
    disabled: boolean
}

const ArrowButton = ({ icon, name, onClick, disabled }: ArrowButtonProps) => {
    return (
        <button
            disabled={disabled}
            className={`${styles.button} ${disabled ? styles.disabled : ''}`}
            onClick={onClick}
        >
            <div className={styles.buttonContent}>
                <div className={styles.buttonIcon}>{icon}</div>
                <div className={styles.buttonName}>{name}</div>
            </div>
            <div className={styles.buttonArrow}>→</div>
        </button>
    )
}

export default ArrowButton
